import { render, staticRenderFns } from "./planesIndex.vue?vue&type=template&id=527a3fc0&scoped=true"
import script from "./planesIndex.vue?vue&type=script&lang=js"
export * from "./planesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a3fc0",
  null
  
)

export default component.exports